var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { withPaymentBotToken } from "./recaptcha";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { Card } from "../card";
import { RadixLoading } from "../primitives/RadixLoading";
import { useCreditPaymentContext } from "./CreditPaymentContext";
import { PaymentErrorNotice } from "./PaymentErrorNotice";
import { RadixCheckbox } from "../primitives/RadixCheckbox";
import { useOrderIntent } from "../../providers";
import { bugsnagClient } from "../../themes/streamlined/streamlined";
var SHIFT4_SDK_URL = "https://i4m.i4go.com/js/jquery.i4goTrueToken.js";
var SHIFT4_SDK_LOAD_TIMEOUT_MS = 10000;
var SHIFT4_FRAME_NOT_READY_CODE = "shift4_frame_not_ready";
var shift4SdkLoadPromise = null;
var getShift4JQuery = function () {
    var _a, _b;
    // Shift4 attaches its plug-in to the global `jQuery` object. Prefer that exact
    // instance so replacing `window.$` later cannot make a loaded plug-in invisible.
    if (typeof window.jQuery === "function" && typeof ((_a = window.jQuery.fn) === null || _a === void 0 ? void 0 : _a.i4goTrueToken) === "function") {
        return window.jQuery;
    }
    if (typeof window.$ === "function" && typeof ((_b = window.$.fn) === null || _b === void 0 ? void 0 : _b.i4goTrueToken) === "function") {
        return window.$;
    }
    return null;
};
var findShift4SdkScript = function () {
    return document.querySelector('script[src*="jquery.i4goTrueToken.js"]');
};
var loadShift4Sdk = function () {
    if (getShift4JQuery() !== null) {
        return Promise.resolve({ loaded: true, source: "already_available" });
    }
    // The SDK invokes the global `jQuery` identifier while it executes, so loading
    // it cannot succeed until that global is available.
    if (typeof window.jQuery !== "function") {
        return Promise.resolve({
            loaded: false,
            reason: "jquery_unavailable",
            source: "not_attempted",
        });
    }
    // Frame resets and React effect reruns must share one in-flight SDK request.
    if (shift4SdkLoadPromise !== null) {
        return shift4SdkLoadPromise;
    }
    var script = findShift4SdkScript();
    var source = script === null ? "injected_script" : "existing_script";
    var previousLoadState = script === null || script === void 0 ? void 0 : script.dataset.shift4LoadState;
    var existingScriptFinishedWithoutPlugin = script !== null && (previousLoadState === "loaded" ||
        previousLoadState === "failed" ||
        (typeof previousLoadState === "undefined" && document.readyState === "complete"));
    if (existingScriptFinishedWithoutPlugin) {
        // A completed script without the plug-in either failed during execution or
        // attached to an obsolete jQuery instance. Reload it against the current one.
        script === null || script === void 0 ? void 0 : script.remove();
        script = null;
        source = "reloaded_script";
    }
    if (script === null) {
        script = document.createElement("script");
        script.src = SHIFT4_SDK_URL;
        script.async = true;
        script.dataset.shift4LoadState = "loading";
    }
    var sdkScript = script;
    var loadPromise = new Promise(function (resolve) {
        var settled = false;
        var finish = function (result) {
            if (settled)
                return;
            settled = true;
            window.clearTimeout(timeout);
            sdkScript.removeEventListener("load", handleLoad);
            sdkScript.removeEventListener("error", handleError);
            resolve(result);
        };
        var handleLoad = function () {
            sdkScript.dataset.shift4LoadState = "loaded";
            finish(getShift4JQuery() !== null
                ? { loaded: true, source: source }
                : { loaded: false, reason: "shift4_sdk_loaded_without_plugin", source: source });
        };
        var handleError = function () {
            sdkScript.dataset.shift4LoadState = "failed";
            finish({ loaded: false, reason: "shift4_sdk_load_failed", source: source });
        };
        var timeout = window.setTimeout(function () {
            finish({ loaded: false, reason: "shift4_sdk_load_timeout", source: source });
        }, SHIFT4_SDK_LOAD_TIMEOUT_MS);
        sdkScript.addEventListener("load", handleLoad);
        sdkScript.addEventListener("error", handleError);
        if (!sdkScript.isConnected) {
            // Append only after listeners are registered so cached, immediate loads
            // cannot complete before their outcome is observed.
            document.head.appendChild(sdkScript);
        }
    });
    shift4SdkLoadPromise = loadPromise;
    void loadPromise.then(function () {
        if (shift4SdkLoadPromise === loadPromise) {
            // Deduplication is only needed while loading. A later effect must
            // re-check the plug-in in case another script replaced global jQuery.
            shift4SdkLoadPromise = null;
        }
    });
    return loadPromise;
};
export var Shift4HostedPaymentForm = function () {
    var _a = useCreditPaymentContext(), processorInfo = _a.processorInfo, cart = _a.cart, isGuestUser = _a.isGuestUser, reportProcessorError = _a.reportProcessorError, clearPaymentError = _a.clearPaymentError, paymentError = _a.paymentError, handleCreditOrderComplete = _a.handleCreditOrderComplete, markPaymentSubmitting = _a.markPaymentSubmitting, checkoutUserId = _a.checkoutUserId, checkoutComment = _a.checkoutComment, shouldStoreCard = _a.shouldStoreCard, setShouldStoreCard = _a.setShouldStoreCard, isCurbsideOrder = _a.isCurbsideOrder, shouldSendSmsAlerts = _a.shouldSendSmsAlerts, hasMarketingOptIn = _a.hasMarketingOptIn, smsNumber = _a.smsNumber, signUpRewards = _a.signUpRewards;
    var currentAddress = useOrderIntent().currentAddress;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(0), frameResetNonce = _c[0], setFrameResetNonce = _c[1];
    var _d = useState(true), iframeLoading = _d[0], setIframeLoading = _d[1];
    var rewardsSignupPayload = useMemo(function () { return (signUpRewards ? { sign_up_rewards: true } : {}); }, [signUpRewards]);
    var submitShift4OrderRef = useRef();
    var resetShift4Frame = useCallback(function () {
        setIframeLoading(true);
        setFrameResetNonce(function (nonce) { return nonce + 1; });
    }, []);
    var handleShift4Error = useCallback(function (code, message) {
        reportProcessorError("shift4", { code: code, message: message });
        resetShift4Frame();
    }, [reportProcessorError, resetShift4Frame]);
    var submitShift4Order = useCallback(function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var response, rawOrder, order, error_1, reason;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        return __generator(this, function (_t) {
            switch (_t.label) {
                case 0:
                    setLoading(true);
                    markPaymentSubmitting(true);
                    clearPaymentError();
                    _t.label = 1;
                case 1:
                    _t.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, withPaymentBotToken(__assign(__assign(__assign(__assign({}, payload), { cart_id: cart === null || cart === void 0 ? void 0 : cart.id, card_friendly_name: null, should_store_card: !isGuestUser && shouldStoreCard, address_id: currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.id, user_id: checkoutUserId, comment: checkoutComment, is_curbside_order: isCurbsideOrder, should_send_sms_alerts: shouldSendSmsAlerts, sms_number: smsNumber, has_marketing_opt_in: hasMarketingOptIn }), rewardsSignupPayload), { headers: {
                                "X-CSRF-TOKEN": (_a = window.session) === null || _a === void 0 ? void 0 : _a.token,
                                credentials: "same-origin",
                                "Content-Type": "application/json",
                                Accept: "application/json",
                                "X-Requested-With": "XMLHttpRequest",
                            } })).then(function (paymentData) { return axios.post("".concat(window.relativeURI(), "/order/shift4"), paymentData); })];
                case 2:
                    response = _t.sent();
                    if (response.status !== 200) {
                        handleShift4Error("shift4_submit_error", "There was an error while processing this card. Please try again.");
                        return [2 /*return*/];
                    }
                    rawOrder = (_b = response.data) === null || _b === void 0 ? void 0 : _b.order_data;
                    order = typeof rawOrder === "string" ? JSON.parse(rawOrder) : (_c = response.data) === null || _c === void 0 ? void 0 : _c.order;
                    if (!order) {
                        handleShift4Error("shift4_submit_error", "There was an error while processing this card. Please try again.");
                        return [2 /*return*/];
                    }
                    handleCreditOrderComplete(order);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _t.sent();
                    reason = axios.isAxiosError(error_1)
                        ? String((_s = (_p = (_l = (_g = (_f = (_e = (_d = error_1.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.friendly) === null || _f === void 0 ? void 0 : _f.description) !== null && _g !== void 0 ? _g : (_k = (_j = (_h = error_1.response) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.friendly) === null || _k === void 0 ? void 0 : _k.message) !== null && _l !== void 0 ? _l : (_o = (_m = error_1.response) === null || _m === void 0 ? void 0 : _m.data) === null || _o === void 0 ? void 0 : _o.message) !== null && _p !== void 0 ? _p : (_r = (_q = error_1.response) === null || _q === void 0 ? void 0 : _q.data) === null || _r === void 0 ? void 0 : _r.error) !== null && _s !== void 0 ? _s : "")
                        : "";
                    handleShift4Error("shift4_submit_error", reason || "There was an error while processing this card. Please try again.");
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    markPaymentSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        checkoutComment,
        checkoutUserId,
        clearPaymentError,
        currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.id,
        handleCreditOrderComplete,
        isGuestUser,
        isCurbsideOrder,
        hasMarketingOptIn,
        markPaymentSubmitting,
        handleShift4Error,
        shouldSendSmsAlerts,
        shouldStoreCard,
        smsNumber,
        rewardsSignupPayload,
    ]);
    useEffect(function () {
        submitShift4OrderRef.current = function (payload) {
            void submitShift4Order(payload);
        };
    }, [submitShift4Order]);
    useEffect(function () {
        var _a, _b;
        var transactionInfo = ((_a = processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.transactionInfo) !== null && _a !== void 0 ? _a : {});
        var requestInfo = ((_b = transactionInfo.Request) !== null && _b !== void 0 ? _b : {});
        var server = requestInfo.i4go_server;
        var accessBlock = requestInfo.i4go_accessblock;
        if ((processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.transactionInfo) == null) {
            return;
        }
        if (typeof server !== "string" || typeof accessBlock !== "string") {
            reportProcessorError("shift4", {
                code: "shift4_configuration_error",
                message: "The payment form could not be configured. Please refresh the page and try again.",
            });
            setIframeLoading(false);
            return;
        }
        var cancelled = false;
        var readinessStartedAt = Date.now();
        var reportFrameNotReady = function (reason, sdkLoadSource, initializationErrorName) {
            var _a, _b;
            if (initializationErrorName === void 0) { initializationErrorName = null; }
            if (cancelled)
                return;
            var pluginAvailableOnDollar = typeof window.$ === "function" &&
                typeof ((_a = window.$.fn) === null || _a === void 0 ? void 0 : _a.i4goTrueToken) === "function";
            var pluginAvailableOnJQuery = typeof window.jQuery === "function" &&
                typeof ((_b = window.jQuery.fn) === null || _b === void 0 ? void 0 : _b.i4goTrueToken) === "function";
            bugsnagClient.notify(new Error(SHIFT4_FRAME_NOT_READY_CODE), function (event) {
                var _a, _b;
                event.context = "Shift4 hosted payment form initialization";
                event.groupingHash = "".concat(SHIFT4_FRAME_NOT_READY_CODE, ":").concat(reason);
                event.addMetadata("shift4FrameReadiness", {
                    reason: reason,
                    sdkLoadSource: sdkLoadSource,
                    initializationErrorName: initializationErrorName,
                    elapsedMilliseconds: Date.now() - readinessStartedAt,
                    configuredSdkLoadTimeoutMilliseconds: SHIFT4_SDK_LOAD_TIMEOUT_MS,
                    frameResetNonce: frameResetNonce,
                    documentReadyState: document.readyState,
                    documentVisibilityState: document.visibilityState,
                    browserOnline: navigator.onLine,
                    dollarAvailable: typeof window.$ === "function",
                    jqueryAvailable: typeof window.jQuery === "function",
                    jqueryGlobalsMatch: window.$ === window.jQuery,
                    jqueryVersion: typeof window.jQuery === "function"
                        ? String((_b = (_a = window.jQuery.fn) === null || _a === void 0 ? void 0 : _a.jquery) !== null && _b !== void 0 ? _b : "unknown")
                        : null,
                    frameElementPresent: document.getElementById("i4goFrame") !== null,
                    pluginAvailableOnDollar: pluginAvailableOnDollar,
                    pluginAvailableOnJQuery: pluginAvailableOnJQuery,
                    shift4ScriptTagCount: document.querySelectorAll('script[src*="jquery.i4goTrueToken.js"]').length,
                    transactionInfoAvailable: (processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.transactionInfo) != null,
                    serverConfigured: typeof server === "string",
                    accessBlockConfigured: typeof accessBlock === "string",
                    paymentTypesConfigured: transactionInfo.payment_types != null,
                });
            });
            reportProcessorError("shift4", {
                code: SHIFT4_FRAME_NOT_READY_CODE,
                message: "The payment form did not finish loading. Please refresh the page and try again.",
            });
            setIframeLoading(false);
        };
        var initializeFrame = function () { return __awaiter(void 0, void 0, void 0, function () {
            var sdkLoadResult, shift4JQuery, frameTarget;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, loadShift4Sdk()];
                    case 1:
                        sdkLoadResult = _f.sent();
                        if (cancelled)
                            return [2 /*return*/];
                        if (!sdkLoadResult.loaded) {
                            reportFrameNotReady((_a = sdkLoadResult.reason) !== null && _a !== void 0 ? _a : "unknown", sdkLoadResult.source);
                            return [2 /*return*/];
                        }
                        shift4JQuery = getShift4JQuery();
                        if (shift4JQuery === null) {
                            reportFrameNotReady("shift4_sdk_loaded_without_plugin", sdkLoadResult.source);
                            return [2 /*return*/];
                        }
                        try {
                            frameTarget = shift4JQuery("#i4goFrame");
                        }
                        catch (error) {
                            reportFrameNotReady("shift4_initialization_threw", sdkLoadResult.source, error instanceof Error ? error.name : "NonErrorThrown");
                            return [2 /*return*/];
                        }
                        if (!frameTarget.length) {
                            reportFrameNotReady("frame_target_missing", sdkLoadResult.source);
                            return [2 /*return*/];
                        }
                        try {
                            frameTarget.empty();
                            frameTarget.i4goTrueToken({
                                server: server,
                                accessBlock: accessBlock,
                                self: document.location,
                                submitButton: {
                                    label: "Pay and Finalize Order"
                                },
                                container: { classes: "mw-100 w-100" },
                                template: "bootstrap5-labeled",
                                streetAddress: {
                                    classes: "",
                                    label: "",
                                    placeholder: "",
                                    message: "",
                                    required: Array.isArray((_b = window.session) === null || _b === void 0 ? void 0 : _b.avs_configs) && window.session.avs_configs.length > 1,
                                    visible: Array.isArray((_c = window.session) === null || _c === void 0 ? void 0 : _c.avs_configs) && window.session.avs_configs.length > 1,
                                },
                                postalCode: {
                                    classes: "",
                                    label: "",
                                    placeholder: "",
                                    message: "",
                                    required: Array.isArray((_d = window.session) === null || _d === void 0 ? void 0 : _d.avs_configs) && window.session.avs_configs.length > 1,
                                    visible: Array.isArray((_e = window.session) === null || _e === void 0 ? void 0 : _e.avs_configs) && window.session.avs_configs.length > 1,
                                },
                                cssRules: [
                                    ".btn { width: 100% !important; }",
                                ],
                                acceptedPayments: transactionInfo.payment_types ? transactionInfo.payment_types : "AX,DC,JC,MC,NS,VS",
                                onSuccess: function (_form, tokenData) {
                                    var _a;
                                    (_a = submitShift4OrderRef.current) === null || _a === void 0 ? void 0 : _a.call(submitShift4OrderRef, tokenData);
                                },
                                onFailure: function (_form, tokenData) {
                                    var _a, _b;
                                    handleShift4Error((_a = tokenData === null || tokenData === void 0 ? void 0 : tokenData.i4go_response) !== null && _a !== void 0 ? _a : "shift4_token_error", (_b = tokenData === null || tokenData === void 0 ? void 0 : tokenData.i4go_responsetext) !== null && _b !== void 0 ? _b : "There was an error while processing this card. Please try again.");
                                },
                                onComplete: function () { },
                            });
                        }
                        catch (error) {
                            reportFrameNotReady("shift4_initialization_threw", sdkLoadResult.source, error instanceof Error ? error.name : "NonErrorThrown");
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        void initializeFrame();
        return function () {
            cancelled = true;
        };
    }, [frameResetNonce, processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.transactionInfo, handleShift4Error, reportProcessorError]);
    useEffect(function () {
        var _a, _b;
        var transactionInfo = ((_a = processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.transactionInfo) !== null && _a !== void 0 ? _a : {});
        var requestInfo = ((_b = transactionInfo.Request) !== null && _b !== void 0 ? _b : {});
        var server = requestInfo.i4go_server;
        var expectedOrigin = null;
        if (typeof server === "string") {
            try {
                expectedOrigin = new URL(server, window.location.href).origin;
            }
            catch (_c) {
                expectedOrigin = null;
            }
        }
        var resolved = false;
        var finish = function () {
            if (resolved)
                return;
            resolved = true;
            setIframeLoading(false);
        };
        var handler = function (event) {
            if (expectedOrigin === null || event.origin !== expectedOrigin)
                return;
            finish();
        };
        window.addEventListener("message", handler);
        //If the message doesn't post, ensure the loading state is unset.
        var timeout = setTimeout(function () {
            finish();
        }, 5000);
        return function () {
            window.removeEventListener("message", handler);
            clearTimeout(timeout);
        };
    }, [frameResetNonce, processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.transactionInfo]);
    return (React.createElement(Card, { className: "radix-credit-payment-form radix-credit-payment-form--shift4" },
        React.createElement(PaymentErrorNotice, { error: paymentError }),
        React.createElement("h3", { className: "radix-credit-payment-title" }, "Card Details"),
        !isGuestUser ? (React.createElement("div", { className: "form-check m-2 text-left" },
            React.createElement(RadixCheckbox, { className: "form-check-input", id: "save_card_check", checked: shouldStoreCard, label: "Save payment method?", onCheckedChange: function (checked) {
                    setShouldStoreCard(checked);
                } }))) : null,
        loading ? React.createElement(RadixLoading, { label: "Processing payment" }) : null,
        iframeLoading ? React.createElement(RadixLoading, { label: "Loading Payment Form" }) : null,
        React.createElement("div", { id: "form-main", className: "mt-2", style: { visibility: iframeLoading ? "hidden" : "visible" } },
            React.createElement("div", { style: { minWidth: '100%' }, id: "i4goFrame", key: frameResetNonce }))));
};
